import type { PromoCarouselTracking } from "@membership/ui.components";
import { track, trackClick } from "tracking";

const onChevronClicked: PromoCarouselTracking["onChevronClicked"] = ({
  location_type,
  module_content,
  module_content_details
}) => {
  trackClick({
    event: "Page Element Clicked",
    properties: {
      location_type,
      module_content,
      module_content_details
    }
  });
};

const onMessageClicked: PromoCarouselTracking["onMessageClicked"] = ({
  location_type,
  module_content,
  module_content_details,
  module_content_url
}) => {
  trackClick({
    event: "Page Element Clicked",
    properties: {
      location_type,
      module_content,
      module_content_details,
      module_content_url
    }
  });
};

const onMessageViewed: PromoCarouselTracking["onMessageViewed"] = ({
  location_type,
  module_content,
  module_content_details
}) => {
  track({
    event: "Page Element Viewed",
    properties: {
      location_type,
      module_content,
      module_content_details
    }
  });
};

const onBannerClicked: PromoCarouselTracking["onBannerClicked"] = ({
  location_type,
  module_content
}) => {
  trackClick({
    event: "Page Element Clicked",
    properties: {
      location_type,
      module_content
    }
  });
};

export const useTracking = () => {
  return {
    onBannerClicked,
    onMessageViewed,
    onMessageClicked,
    onChevronClicked
  };
};
